import ProductTile from 'components/gruenland/molecules/product-tile/ProductTile';
import useSelectedColorFilterVariantIndex from 'helpers/hooks/useSelectedColorFilterVariantIndex';
import { Product } from 'types/entity/product';
import { useProductList } from '../../context';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';

interface ProductTileWrapperProps {
  product: Product;
  isSearchResult?: boolean;
  disableQuickView?: boolean;
  disableWishlistButton?: boolean;
  onClick?: () => void;
}

const PlpProductTileWrapper: React.FC<ProductTileWrapperProps> = ({ product, isSearchResult, onClick }) => {
  const { wishlist, addToWishlist, removeFromWishlist } = useProductList();

  const selectedColorVariantIndex = useSelectedColorFilterVariantIndex(product.variants);
  const [isTabletSize] = useMediaQuery(tablet);

  return (
    <ProductTile
      product={product}
      wishlist={wishlist}
      selectedVariantIndex={selectedColorVariantIndex}
      isSearchResult={isSearchResult}
      onClick={onClick}
      addToWishlist={addToWishlist}
      removeLineItem={removeFromWishlist}
      disableVariants={!isTabletSize}
    />
  );
};

export default PlpProductTileWrapper;
